export const MOTION = {
    durationMs: {
        micro: 120,
        component: 180,
        layout: 260,
        emphasis: 360,
        toastExit: 140,
    },
    easing: {
        standard: [0.2, 0, 0, 1] as const,
        emphasis: [0.22, 1, 0.36, 1] as const,
    },
} as const;

export const MOTION_SECONDS = {
    micro: MOTION.durationMs.micro / 1000,
    component: MOTION.durationMs.component / 1000,
    layout: MOTION.durationMs.layout / 1000,
    emphasis: MOTION.durationMs.emphasis / 1000,
    toastExit: MOTION.durationMs.toastExit / 1000,
} as const;

export const FRAMER_TRANSITIONS = {
    micro: {
        duration: MOTION_SECONDS.micro,
        ease: MOTION.easing.standard,
    },
    component: {
        duration: MOTION_SECONDS.component,
        ease: MOTION.easing.standard,
    },
    layout: {
        duration: MOTION_SECONDS.layout,
        ease: MOTION.easing.standard,
    },
    emphasis: {
        duration: MOTION_SECONDS.emphasis,
        ease: MOTION.easing.emphasis,
    },
    toastExit: {
        duration: MOTION_SECONDS.toastExit,
        ease: MOTION.easing.standard,
    },
} as const;

export const SPRING = {
    cardHover: {
        type: 'spring' as const,
        stiffness: 300,
        damping: 30,
        mass: 0.8,
    },
    gentle: {
        type: 'spring' as const,
        stiffness: 200,
        damping: 25,
        mass: 1,
    },
} as const;

export const STAGGER = {
    fast: { staggerChildren: 0.04, delayChildren: 0.1 },
    slow: { staggerChildren: 0.08, delayChildren: 0.15 },
} as const;

export const SCROLL_TRIGGER = {
    hero: { once: true, amount: 0.3 },
    section: { once: true, amount: 0.2 },
} as const;
